// extracted by mini-css-extract-plugin
export default {"getOutline":"GamesList_getOutline__T8GJk"};